import * as types from "./actionTypes";

export const foodHandlingSubmitted = () => ({
  type: types.FOOD_HANDLING_FORM_SUBMITTED,
});

export const manualHandlingSubmitted = () => ({
  type: types.MANUAL_HANDLING_FORM_SUBMITTED,
});

export const cashAlcoholSubmitted = () => ({
  type: types.CASH_ALCOHOL_SUBMITTED,
});

export const nightWorkerSubmitted = () => ({
  type: types.NIGHT_WORKER_SUBMITTED,
});

export const authorityForPaymentsSubmitted = () => ({
  type: types.AUTHORITY_FOR_PAYMENTS_SUBMITTED,
});

export const contractForServicesSubmitted = () => ({
  type: types.CONTRACT_FOR_SERVICES_SUBMITTED,
});

export const nonHGVSubmitted = () => ({
  type: types.NON_HGV_ASSESSMENT_SUBMITTED,
});

export const nonHGVPassed = () => ({
  type: types.NON_HGV_ASSESSMENT_PASSED,
});

export const driverAssessmentSubmitted = () => ({
  type: types.DRIVER_ASSESSMENT_SUBMITTED,
});

export const driverAssessmentPassed = () => ({
  type: types.DRIVER_ASSESSMENT_PASSED,
});

export const postNightWorkerForm = (formName, formContent) => ({
  type: types.POST_NIGHT_WORKER_FORM,
  payload: { formName, formContent },
});

export const postAuthorityForPaymentsForm = (formName, formContent) => ({
  type: types.POST_AUTHORITY_FOR_PAYMENTS_FORM,
  payload: { formName, formContent },
});
